import { render, staticRenderFns } from "./SmallCarousel.vue?vue&type=template&id=2ff9d18e"
import script from "./SmallCarousel.vue?vue&type=script&lang=js"
export * from "./SmallCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports